/* eslint-disable import/prefer-default-export */
import { _firestore } from '@/lib/db';
import store from '@/store';

export const GetReplies = ( cb = null ) => {

	const getReplies = ( querySnapshot ) => {
		const replies = [];

		querySnapshot.forEach( ( doc ) => {
			replies.push( {
				id : doc.id,
				...doc.data()
			} );
		} );

		return replies;

	};

	const repliesRef = _firestore
		.collection( `users/${store.state.user.uid}/replies` )
		.orderBy( 'createdAt', 'desc' );

	if ( !cb ) {
		return repliesRef
			.get()
			.then( getReplies );
	}

	return repliesRef
		.onSnapshot( ( querySnapshot ) => {
			const replies = getReplies( querySnapshot );
			cb( replies );
		} );

};

export const GetRepliesWithRange = ( start, increment, cb = null ) => {

	const getReplies = ( querySnapshot ) => {
		const replies = [];

		querySnapshot.forEach( ( doc ) => {
			replies.push( {
				id : doc.id,
				...doc.data()
			} );
		} );

		return replies;

	};

	const repliesRef = _firestore
		.collection( `users/${store.state.user.uid}/replies` )
		.orderBy( 'createdAt', 'desc' );

	if ( start === undefined || start === -1 ) {

		// no start index and no callback
		if ( !cb ) {
			return repliesRef
				.limit( increment )
				.get()
				.then( getReplies );
		}

		// no start index and a callback
		return repliesRef
			.limit( increment )
			.onSnapshot( ( querySnapshot ) => {
				const replies = getReplies( querySnapshot );
				cb( replies );
			} );
	}

	// has start index but no callback
	if ( !cb ) {
		return repliesRef
			.startAfter( start )
			.limit( increment )
			.get()
			.then( getReplies );
	}

	// has start index and a callback
	return repliesRef
		.startAfter( start )
		.limit( increment )
		.onSnapshot( ( querySnapshot ) => {
			const replies = getReplies( querySnapshot );
			cb( replies );
		} );

};

export const GetComment = ( asset, commentId ) => {
	// console.log( asset );
	// console.log( commentId );
	_firestore
		.collection( `commentSections/${asset}/comments` )
		.doc( `${commentId}` )
		.get();
};

export const GetCommentPath = async ( sectionId, commentId, path = [] ) => {

	const commentDoc = await GetComment( sectionId, commentId );

	if ( !commentDoc.exists ) {
		throw new Error( 'Comment no longer exists' );
	}

	const comment = commentDoc.data();
	const { id }  = commentDoc;

	if ( comment.replyingTo === 'root' ) {
		path.push( id );
		return path.reverse();
	}

	path.push( id );

	return GetCommentPath( sectionId, comment.replyingTo, path );

};
